module.exports = __webpack_public_path__ + "img/video-placeholder.04060eee.jpg";